module.exports = __webpack_public_path__ + "img/lightadison.1a96c5f2.png";